import { IKeyData } from  "./meta/Drag/index";

/**
 * Return whether to disable the snap to grid or not.
 * @param data {IKeyData | MouseEvent | undefined}
 * @return {Boolean}
 */
export const isSnapToGridDisabled = (data: IKeyData | MouseEvent | undefined) => {
	if (data) {
		if (data instanceof MouseEvent) {
			return data.ctrlKey || data.metaKey;
		} else {
			return data && (data.ctrlKey || data.metaKey);
		}
	}
	return false;
};

/**
 * Return whether to expand shape from center or not.
 * @param keyData {IKeyData}
 * @return {Boolean}
 */
export const isExpandFromCenter = (keyData: IKeyData | undefined) => {
	return keyData && keyData.altKey;
};

/**
 * Return whether to cancel the current drag operation or not
 * @param keyData {IKeyData}
 * @return {Boolean}
 */
export const cancelCurrentOperation = (keyData: IKeyData| undefined) => {
	return (keyData && keyData.escKey) || false;
};

/**
 * Return whether to allow multiple shape selection or not.
 * @param event {MouseEvent}
 * @return {Boolean}
 */
export const allowMultiShapeSelection = (event: MouseEvent) => {
	return event.shiftKey;
};

/**
 * Return whether to maintain aspect ration or not while resizing shape
 * @param keyData {IKeyData}
 * @return {Boolean}
 */
export const maintainAspectRatio = (keyData: IKeyData| undefined) => {
	return keyData && keyData.shiftKey;
};
